import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';

import { Observable } from "rxjs/Observable";

import { AuthenticationService, LocalStorageService, EventService, GameGroupService} from './shared/services';
import { notificationOptions } from './shared/models/NotificationOptions';
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  public closeModal: boolean = false;
  public user: object = null;
  public isUserAuthenticated: boolean = false;
  public options = notificationOptions;
  public menuOverlayShown:Boolean = false;
  public showOverlay = true;
  @ViewChild('headerComponent') private headerComponent;

  constructor(private authenticationService: AuthenticationService,
    private eventService: EventService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private gameGroupService: GameGroupService) {

    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event)
    })

  }
  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.menuOverlayShown = false;
      this.showOverlay = true;
    }
    if (event instanceof NavigationEnd) {
      this.showOverlay = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.showOverlay = false;
    }
    if (event instanceof NavigationError) {
      this.showOverlay = false;
    }
  }

  ngOnInit(): any {
    this.initSite().then(() => {
      this.setEvents();
      this.showOverlay = false;
    }).catch(error=>{
      this.showOverlay = false;
      //add a notification here to tell the user that something went wrong
    });
  }

  ngOnDestroy(): any {
    this.authenticationService.alive = false;
    this.isUserAuthenticated = false;
    this.authenticationService.isUserLoggedIn = false;
  }


  private setEvents(): void {
    this.eventService.getUserInfo()
      .subscribe(data => {
        this.setUserData(data.user);
      });
    this.eventService.getAuthenticationStatus()
      .subscribe(data => {
        this.setUserStatus(data.status);
      });
    this.gameGroupService.getGameGroups()
      .subscribe(response => {
        this.gameGroupService.setCurrentGameGroups(response.data.groups);
      });
  }

  private initSite(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.authenticationService.initSite()
        .subscribe(res => {
          var token = res.token;
          if (token) {
            this.setToken(token);
          }
          this.authenticationService.loginManager(res.data.user, true);
          resolve(res);
        }, err => {
          console.log(err);
          reject(err);
        });
    });
  }

  private setUserData(user): void {
    this.user = user;
    this.localStorageService.setItem('USER_INFO', user);
  }

  private setUserStatus(status) {
    this.isUserAuthenticated = status;
    this.authenticationService.isUserLoggedIn = status;
  }

  private setToken(token) {
    this.localStorageService.setItem("token", token);
  }

  public onLogin(values) {
    this.showOverlay = true;
    this.authenticationService.login(values)
      .delay(500)
      .subscribe(res => {
        if (res.status) {
          this.headerComponent.closeModal();
          this.authenticationService.loginManager(res.data.user, true);
        }
        this.showOverlay = false;
      }, err => {
        this.showOverlay = false;
        console.log(err);
      }, () => {
      });
  }

  public onLogout() {
    this.showOverlay = true;
    this.authenticationService.logout()
      .subscribe(response => {
        if (response.status) {
          this.showOverlay = false;
          this.initSite()
            .then(status => {
              this.authenticationService.loginManager(response.data.user, false);
              this.authenticationService.alive = false;
            })
            .catch(err => {
              console.log(err);
            });
        }
      });

  }
  onMenuToggle(menuShown){
    //menu is visible
    if(menuShown){
      this.menuOverlayShown = true;
    }
    else{
      this.menuOverlayShown = false;
    }
  }
  onOverlayClick(){
    this.menuOverlayShown = !this.menuOverlayShown;
  }
}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/app.component.ts